import React from 'react';
import data from '../data.json';
import './WorkDetailsProcess.css';

const WorkDetailsProcess = ({ workId }) => {
    // Trouver le travail correspondant à l'ID fourni
    const work = data.work.find(item => item.id === workId);

    if (!work) {
        return <div>Travail non trouvé</div>;
    }

    return (
        <div className="work-details-process">
            <h2 className="process-title">Process</h2>
            <div className="process-text-container">
                <div>
                    <p>{work.process1}</p>
                    {work.imageprocess1 && <img src={process.env.PUBLIC_URL + '/' + work.imageprocess1} alt="Process 1" className="process-image"/>}
                </div>
                {work.process2 && (
                    <div>
                        <p>{work.process2}</p>
                        {work.imageprocess2 && <img src={process.env.PUBLIC_URL + '/' + work.imageprocess2} alt="Process 2" className="process-image"/>}
                    </div>
                )}
                {work.process3 && (
                    <div>
                        <p>{work.process3}</p>
                        {work.imageprocess3 && <img src={process.env.PUBLIC_URL + '/' + work.imageprocess3} alt="Process 3" className="process-image"/>}
                    </div>
                )}
                {work.process4 && (
                    <div>
                        <p>{work.process4}</p>
                        {work.imageprocess4 && <img src={process.env.PUBLIC_URL + '/' + work.imageprocess4} alt="Process 4" className="process-image"/>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WorkDetailsProcess;
